import stockAPI from "@/utility/api.js";

export default {
  async fetchNewlyAddedNewsAll({ getters, commit }) {
    const query = new URLSearchParams({
      started_at: getters.startedAt,
      ended_at: getters.endedAt,
      key_word: getters.keyWord,
      page: getters.page
    });
    const res = await stockAPI.GET(`api/news?${query.toString()}`);
    if (res) {
      commit("perPage", res.per_page);
      commit("totalListItems", res.total);
      commit("newlyAddedNewsAll", res);
      return Promise.resolve();
    }
  },
  async fetchNewlyAddedSurveyAll({ getters, commit }) {
    const query = new URLSearchParams({
      started_at: getters.startedAt,
      ended_at: getters.endedAt,
      key_word: getters.keyWord,
      page: getters.page
    });
    const res = await stockAPI.GET(`api/researches?${query.toString()}`);
    if (res) {
      commit("perPage", res.per_page);
      commit("totalListItems", res.total);
      commit("newlyAddedSurveyAll", res);
      return Promise.resolve();
    }
  }
};
